(function() {
/*
    Brings data from publicityService into scope
*/
'use strict';

angular.module('TR')
    .directive('publicityData', publicityService => ({
        restrict: 'A',
        scope: false, // Use parent scope
        link(scope) {
            publicityService
                .getStats({
                    StatisticTypes: 'All'
                })
                .then(data => {
                    // Add returned data to scope
                    scope.publicityData = data;
                });
        }
    }));
})();
